<template>
	<div>
		<modal ref="modal" @modal-fechou="() => modalFechou()">
			<div style="min-height: 400px">
				<button type="button" class="close" @click="$refs.modal.modalHide()">
					<span aria-hidden="true">&times;</span>
				</button>

				<!-- lista com dos despachos -->
				<div v-if="exibir == 'LD'">
					<h4 class="modal-title">SELECIONE UM DESPACHO</h4>

					<hr style="margin-top: 6px" />

					<div class="row">
						<div class="col-xs-12">
							<p class="text-info" v-if="temAeronave">
								<i class="fa fa-fw fa-info-circle"></i>Encontramos mais de um despacho para essa aeronave, selecione qual despacho
								esse voo se refere.
							</p>
							<p class="text-info" v-if="!temAeronave">
								<i class="fa fa-fw fa-info-circle"></i>Não encontramos nenhum despacho para essa aeronave, selecione um na lista
								ou insira um despacho.
							</p>
						</div>
					</div>

					<div v-show="despachos.length > 0" class="row form-group">
						<div class="col-xs-12">
							<i class="fa fa-search icone-busca" aria-hidden="true"></i>
							<input
								type="text"
								style="padding-left: 22px; margin-top: 7px"
								:placeholder="_traducao('global', 'buscar')"
								v-model.trim="buscaDespacho"
								class="form-control"
							/>
						</div>
					</div>

					<div class="row" style="margin-top: 4px">
						<div class="col-sm-12">
							<div
								ref="scrollDespacho"
								class="scroll"
								style="overflow-y: scroll"
								:style="{'max-height': this._height - 250 + 'px'}"
							>
								<div class="table-responsive">
									<table class="table table-lista table-striped table-siga table-hover">
										<thead>
											<tr>
												<th>Nº do Despacho</th>

												<th>Tipo</th>

												<th>Histórico</th>

												<th>Aeronave</th>

												<th class="text-center">Base</th>
												<th class="text-center"> {{ _traducao('global', 'inicio') }} </th>
											</tr>
										</thead>
										<tbody>
											<tr
												class="table-hover-tr"
												@click="clickSelecinouDespacho(item)"
												v-for="(item, index) in _despachos"
												:key="index"
											>
												<td>
													{{ item.numero }}
												</td>
												<td>
													{{ item._tipo }}<br />
													<small v-if="item.id_ordem_missao != null">{{ item.ordem_codigo }}</small>
												</td>
												<td>
													{{ item.historico }}
												</td>
												<td>
													<span v-for="(aero, idx) in item.aeronave" :key="idx">
														<span v-for="(a, i) in aeronaves" :key="i" v-if="a.id == aero.id_aeronave"
															>{{ a.codinome }} - {{ a.prefixo }}</span
														><br />
													</span>
												</td>
												<td class="text-center">
													<span v-for="(aero, idx) in item.aeronave" :key="idx">
														<span v-for="b in bases" :key="b.descricao" v-if="b.id == aero.base">{{ b.descricao }}</span
														><br />
													</span>
												</td>
												<td class="text-center">{{ item.data_inicio | dataTempo }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<div v-if="!temAeronave">
						<hr style="margin-top: 6px" />

						<div class="row">
							<div class="col-xs-12">
								<button type="button" class="btn btn-default" @click="clickAddDespacho()">
									<i class="fa fa-fw fa-plus"></i> ADICIONAR DESPACHO
								</button>
							</div>
						</div>
					</div>
				</div>

				<!-- novo despacho -->
				<div v-if="exibir == 'NO'">
					<h4 class="modal-title">NOVO DESPACHO</h4>

					<flDespacho
						:visualizar="false"
						@despacho-add="(despacho) => addDespacho(despacho)"
						:aeronaves="aeronaves"
						:contextos="contextos"
						:subclassificacoes="subclassificacoes"
						ref="despachoCadastro"
					/>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import flDespacho from '../../../despacho/maranhao/cadastro.vue'
export default {
	components: {
		flDespacho
	},

	data() {
		return {
			tipo: '',
			despacho: '',
			despachos: [],
			bases: [],
			aeronave: {},
			buscaDespacho: '',

			ordens: [],

			listaPlanejada: '',

			exibir: '',
			temAeronave: false,

			aeronaves: [],
			contextos: [],
			subclassificacoes: []
		}
	},

	computed: {
		_despachos() {
			if (this.buscaDespacho == '') {
				return _.orderBy(this.despachos, ['numero'], ['desc'])
			}

			var self = this
			var list = this.despachos.filter(function (cust) {
				return (
					cust.numero.toLowerCase().indexOf(self.buscaDespacho.toLowerCase()) >= 0 ||
					cust.historico.toLowerCase().indexOf(self.buscaDespacho.toLowerCase()) >= 0 ||
					cust._tipo.toLowerCase().indexOf(self.buscaDespacho.toLowerCase()) >= 0
				)
			})

			return _.orderBy(list, ['numero'], ['desc'])
		}
	},

	mounted() {
		this._providerBaseOperacional((lista) => (this.bases = lista))

		var configScroll = {
			color: '#AAA',
			size: '5px',
			height: this._height - 600 + 'px',
			alwaysVisible: true,
			railOpacity: 0.9
		}

		this.$nextTick(() => {
			$(this.$refs.scrollDespacho).slimScroll(configScroll)
		})
	},

	methods: {
		clickSelecinouDespacho(despacho) {
			this.emitEventoDespacho(despacho)
		},

		clickAddDespacho() {
			this.exibir = 'NO'

			this.$refs.modal.changeWidh(90)
			this.$nextTick(() => {
				this.$refs.despachoCadastro.novoModal(this.aeronave)
			})
		},

		carregaDespachos() {
			this.listaPlanejada = 'D'

			if (this.despachos.length == 0) {
				this.exibir = 'LD'
				this.validaDespacho(true)
			}
		},

		addDespacho(despacho) {
			bus.$emit('exibir-notificacao', {type: 'success', text: 'Despacho salvo.'})
			this.emitEventoDespacho(despacho)
		},

		emitEventoDespacho(despacho) {
			this.despacho = despacho
			this.$refs.modal.modalHide()
		},

		modalFechou() {
			if (this.despacho != '') {
				this.$emit('selecionou-despacho', this.despacho)
			}
		},

		validaDespacho(modal) {
			bus.$emit('load-in', {text: 'Carregando dados'})

			this._httpGet('cta-maranhao/Despacho_emergencial/get_aberto', (response) => {
				bus.$emit('load-out')
				console.log(response)
				if (response._request) {
					response.lista = response.lista.map((item) => {
						if (item.tipo == 'P') {
							item._tipo = 'PLANEJADA'
						}

						if (item.tipo == 'C') {
							item._tipo = 'CRÍTICA'
						}

						if (item.tipo == 'E') {
							item._tipo = 'EMERGENCIAL'
						}
						return item
					})

					

					// abre modal para inserir um despacho
					if (response.lista.length == 0) {
						this.$refs.modal.modalShow(80)
						// abre modal para inserir um novo despacho
						this.clickAddDespacho()
					} else {
						// pego os despachos da aeroanve
						var despachos = []

						for (var i in response.lista) {
							for (var j in response.lista[i].aeronave) {
								if (response.lista[i].aeronave[j].id_aeronave == this.aeronave.id) {
									despachos.push(response.lista[i])
									break
								}
							}
						}

						// não tem nenhum despacho para a aeronave selecionada
						if (despachos.length == 0) {
							this.despachos = response.lista
							this.exibir = 'LD' // exibe a lista de despachos
							this.temAeronave = false
							this.$refs.modal.modalShow(80)
							// exibe o modal para escolher um despacho
						} else {
							// tem somente um despacho, seta direto
							if (despachos.length == 1) {
								this.$emit('selecionou-despacho', despachos[0])
								//this.emitEventoDespacho(despachos[0])
							} else {
								this.despachos = despachos
								this.temAeronave = true
								this.exibir = 'LD' // exibe a lista de despachos
								this.$refs.modal.modalShow(80)
								// exibe o modal para escolher qual o despacho
							}
						}
					}
				}
			})
		},

		limpaForm() {
			this.despacho = ''
			this.despachos = []
			this.aeronave = {}
			this.buscaDespacho = ''
			this.ordens = []
			this.listaPlanejada = ''
			this.exibir = ''
			this.temAeronave = false
			this.evento = {}
		},

		carregaDados(aeronave) {
			this.limpaForm()

			this.aeronave = aeronave
			this.validaDespacho(true)

			this._providerContextoOperativo((lista) => {
				this.contextos = lista
			})

			// AERONAVE
			this._providerAeronave((lista) => {
				this.aeronaves = lista
			})

			this._providerSubclassificacao((lista) => {
				this.subclassificacoes = lista
			})
		}
	}
}
</script>

<style>
.table-hover-tr:hover td {
	background: #f0f0f0;
	cursor: pointer;
}

.bk-success {
	background: #dff0d8 !important;
}

.trecho-borda-click-passageiro:hover {
	background: #f9f9f9;
}

.btn-remover-orgao {
	color: red !important;
}

.add:hover {
	background: #fff;
}

.add-modal:hover {
	background: #ddd;
}
</style>